export default __webpack_public_path__ + "static/media/img-placeholder.09a16923.svg";